import * as React from "react";
import { StyleSheet } from "react-native";
import useThemeColor from "../../hooks/useThemeColor";
import Colors from "../../constants/Colors";
import Text from "../Themed/Text";
import View from "../Themed/View";
import { Feather } from "@expo/vector-icons";
import { Controller } from "react-hook-form";
import Pressable from "../Pressable";

type ThemeProps = {
  lightColor?: string;
  darkColor?: string;
  transparent?: boolean;
  checked?: boolean;
  label?: string;
  control?: any;
  name: string;
  required?: boolean;
  errors?: any;
};

export type CheckBoxProps = ThemeProps & Pressable["props"];

export default function CheckBox(props: CheckBoxProps) {
  const {
    style,
    lightColor,
    darkColor,
    transparent = false,
    checked = false,
    label = "",
    control,
    name,
    required = false,
    errors,
    ...otherProps
  } = props;

  const backgroundColor = transparent
    ? "transparent"
    : useThemeColor({ light: lightColor, dark: darkColor }, "background");

  const [isChecked, setIsChecked] = React.useState(false);

  return (
    <Controller
      control={control}
      rules={{
        required: required,
      }}
      render={({ field: { onChange, onBlur, value } }) => (
        <Pressable
          style={[styles.container, style]}
          onPress={() => {
            setIsChecked(!isChecked), onChange(!isChecked);
          }}
        >
          <View style={styles.checkBox}>
            {checked ||
              (isChecked && (
                <Feather
                  style={{}}
                  name={"check"}
                  size={14}
                  color={Colors.base_colors_white}
                />
              ))}
          </View>
          <Text size={16} lightColor={Colors.nuetral_grey_700}>
            {label}
            {errors[name] && (
              <Text size={12} lightColor="red">
                *This is required
              </Text>
            )}
          </Text>
        </Pressable>
      )}
      name={name}
    />
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
  },
  checkBox: {
    height: 16,
    width: 16,
    borderRadius: 4,
    borderWidth: 1,
    borderColor: Colors.primary_500,
    backgroundColor: Colors.primary_500,
    marginRight: 8,
  },
});
